import Animated, { FadeIn, FadeOut } from 'react-native-reanimated';
import { t } from 'util/stdtypes';

import { TitleTag } from './title-tag';

export function AnimatedYouTag({ comment }: { comment?: string | null | undefined }) {
    return (
        <Animated.View entering={FadeIn} exiting={FadeOut}>
            {comment ? (
                <TitleTag formatParams={{ comment }} label={t('poll.you_comment', 'You ({comment})')} type='you' />
            ) : (
                <TitleTag label={t('poll.you', 'You')} type='you' />
            )}
        </Animated.View>
    );
}
